import React from 'react'
import { ReactComponent as DelhaizeSvg} from '../../assets/svgs/clients/Delhaize.svg';

const DelhaizeLogo = () => (
    <div>
        <DelhaizeSvg/>
    </div>
)

export default DelhaizeLogo